import React from 'react';
import Board from './components/board/Board';

class App extends React.Component {
  public render() {
    return (
      <Board />
    );
  }
}

export default App;
